<template>
  <div class="base-section sm notFound white base">
    <div class="container">
      <h1 class="mb-4 font-semibold text-[32px]">
        <strong>{{ $t('youSeemLost') }}</strong>
      </h1>

      <NuxtLink
        class="animation"
        to="/"
        :title="$t('returnTo', { siteName: confMain.siteName })"
      >
        <img
          src="/img/404-not-found.gif"
          :alt="$t('notFoundAnimation')"
        >
      </NuxtLink>

      <h2 class="h3">
        {{ $t('notFoundDescr') }}
      </h2>
      <h3 class="h1">
        {{ $t('notFoundDescr2') }}
      </h3>
    </div>
  </div>
</template>

<script setup>
const { $i18n: i18n } = useNuxtApp()
const { confMain } = useConfig()
const { getBreadcrumbs } = useBreadcrumbs()
const { layout } = useHelpers()

layout.value = 'notFound'

useHead({
  title: i18n?.t('pageNotFound'),
  meta: [
    { name: 'description', content: i18n?.t('pageNotFound') },
    { name: 'robots', content: 'noindex, nofollow' }
  ]
})

getBreadcrumbs({}, 'notFound')
</script>

<style  lang="scss" scoped>
.notFound {
  text-align: center;
  h1.larger {
    padding: 4rem auto;
    font-size: 4rem;
    line-height: 1;
    text-transform: lowercase;
  }
  h1,
  h2,
  h3 {
    margin: auto;
    color: #ccc;
    font-weight: 400;
  }

  img {
    margin: 0 auto;
  }
}
</style>
